<template>
  <el-select
    v-model="value"
    :disabled="disabled"
    multiple
    filterable
    allow-create
    default-first-option
    placeholder="Type Domain"
    no-data-text="Enter the value and press enter"
    @update:modelValue="update"
  />
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'RefererHostSelect',
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = function (newValue: any) {
      context.emit(
        'update:modelValue',
        newValue.map((x: any) => String(x))
      )
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { update, value }
  }
})
</script>
